export default function prependWebUrl(url?: string) {
  const uri = new URL(url || window.location.href);
  uri.pathname = `/from-web${uri.pathname}`;
  return uri.toString();
}
